<template>
  <div id="hres87u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres87uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :arrNumqes="dropdowns.numqes" 
            :indexSelected="indexSelected"
            :tab3Table="columns[dash.nowLang].detailTab3"
            :tab4Table="columns[dash.nowLang].detailTab4"
            :tab6Table="columns[dash.nowLang].detailTab6" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres87u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>
    
    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :arrFlgssm="dropdowns.flgssm"
            :postHres87uSendApprove="postHres87uSendApprove"
            :codappr="codempid"
            :detailSubmit="detailSubmit"
            :descCodappr="dash.currentUser.username[dash.nowLang]" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres87u/mutation-types'
import detail from 'components/hres87u/detail'
import popupApprove from 'components/hres87u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres87u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres87uColumnsLabels()
    this.receivedHres87uIndex()
    this.receivedHres87uDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES87U_INDEX_DISP,
      detailDisp: types.GET_HRES87U_DETAIL_DISP,
      columns: types.GET_HRES87U_COLUMNS,
      labels: types.GET_HRES87U_LABELS,
      index: types.GET_HRES87U_INDEX,
      indexSelected: types.GET_HRES87U_INDEX_SELECTED,
      detail: types.GET_HRES87U_DETAIL,
      dropdownsNumqes: types.GET_HRES87U_DROPDOWNS_NUMQES,
      dropdowns: types.GET_HRES87U_DROPDOWNS,
      detailSubmit: types.GET_HRES87U_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres87uDetail(detailParams)
      this.receivedHres87uDropdownsNumqes(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres87uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES87U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES87U_PAGE,
      receivedHres87uColumnsLabels: types.RECEIVED_HRES87U_COLUMNS_LABELS,
      receivedHres87uIndex: types.RECEIVED_HRES87U_INDEX,
      receivedHres87uDetail: types.RECEIVED_HRES87U_DETAIL,
      receivedHres87uDetailSubmit: types.RECEIVED_HRES87U_DETAIL_SUBMIT,
      postHres87uSendApprove: types.POST_HRES87U_SEND_APPROVE,
      receivedHres87uDropdowns: types.RECEIVED_HRES87U_DROPDOWNS,
      receivedHres87uDropdownsNumqes: types.RECEIVED_HRES87U_DROPDOWNS_NUMQES
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?b9bb7146